module.exports = __webpack_public_path__ + "img/farming_21.6255ed4b.png";